import React from 'react'
import ReactDOM from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './assets/css/common.css'
import ErrorHandler from './components/ErrorHandler'
import { NotificationProvider } from './context/NotificationContext'
import reportWebVitals from './reportWebVitals'
import { isPrerender } from './seo/prerender'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <NotificationProvider>
      <ErrorBoundary FallbackComponent={ErrorHandler}>
        <BrowserRouter basename="/">
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </NotificationProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
  .then(() => {})
  .catch(() => {})

function initializeAnalaytics () {
  window.addEventListener('load', () => {
    /**
     * Load React GA
     */
    if (window.location.pathname !== '/lib') {
      import('react-ga4').then(module => {
        const ReactGA = module.default
        ReactGA.initialize(`${process.env.REACT_APP_GA4_ID}`)
      }).catch((error: any) => {
        console.log('Error loading ReactGA', error)
      })
    }

    /**
     * Load clarity
     */

    import('react-microsoft-clarity').then(Obj => {
      const { clarity } = Obj
      if (process.env.NODE_ENV !== 'development') {
        clarity.init('ixytmr424e')
      }
    })
  })
}

if (!isPrerender) initializeAnalaytics()
